export enum EditIconTypeEnum {
  FILLED = 'filled',
  FILLED_BACKGROUND = 'filled-background',
  OUTLINED = 'outlined',
}
